import Col from "react-bootstrap/Col";
import {SavModalBody} from "./SavModalBody";
import ModalCustom from "../../ui/modal/ModalCustom";

interface SavModalInterface {
    showModal: boolean,
    onHideModal: Function,
    sav: Object,
}

export const SavModal = ({showModal, onHideModal, sav}: SavModalInterface) => {
    return (
        <>
            <ModalCustom
                show={showModal}
                onHide={onHideModal}
                id={'modal-sav'}
                title={`Détails du SAV de la commande ${sav.reclaNumcde}`}
                titleClassname={'text-center mb-3'}
                bodyClassname={'text-left'}
                content={
                    <>
                        <Col>
                            <SavModalBody sav={sav} />
                        </Col>
                    </>
                }
                footer={true}
                buttonsFooter={[
                    {
                        text: 'Fermer',
                        func: () => onHideModal()
                    }
                ]}
            />
        </>
    );
}
